import React from "react";
import styled from "styled-components";
import Icon from "../../shared/components/icon";
import Layout from "../../shared/components/layout";

const ErrorContainer = styled.div`
  background-color: #ffe3e2;
  border-radius: 8px;
  margin-top: 25px;
  padding: 1rem 1rem 0.5rem;
  font-size: 1rem;
`;

const Title = styled.div`
  margin: 10px 0;
`;

const BtnContainer = styled.div`
  position: fixed;
  width: 80%;
  bottom: 5%;
  left: 10%;
`;

function AccessNotSupported() {
  const logout = () => {
    fetch(process.env.REACT_APP_LOGOUT_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  };

  return (
    <Layout>
      <ErrorContainer>
        <Icon type="red-alert" size={35} />
        <Title className="bold">
          Access to your health information not supported
        </Title>
        <p>
          We’re sorry, but due to your unique plan design, you cannot download
          your Protected Health Information (PHI) to 3rd party apps at this
          time.
        </p>
      </ErrorContainer>
      <BtnContainer>
        <button className="btn btn-primary btn-block bold" onClick={logout}>
          OK
        </button>
      </BtnContainer>
    </Layout>
  );
}

export default AccessNotSupported;
